import { createGlobalStyle } from 'styled-components';

const GlobalScrollbarStyles = createGlobalStyle`
  /* Webkit Scrollbar Styles */
  ::-webkit-scrollbar {
    width: 12px;
    height: 12px;
  }

  ::-webkit-scrollbar-track {
    background: #0a0a0a;
    border-radius: 6px;
    border: 1px solid rgba(0, 255, 0, 0.1);
  }

  ::-webkit-scrollbar-thumb {
    background: linear-gradient(180deg, #00ff00, #00cc00);
    border-radius: 6px;
    border: 2px solid #0a0a0a;
    box-shadow: 0 0 10px rgba(0, 255, 0, 0.3);
  }

  ::-webkit-scrollbar-thumb:hover {
    background: linear-gradient(180deg, #00cc00, #009900);
    box-shadow: 0 0 15px rgba(0, 255, 0, 0.5);
  }

  ::-webkit-scrollbar-thumb:active {
    background: linear-gradient(180deg, #009900, #006600);
  }

  ::-webkit-scrollbar-corner {
    background: #0a0a0a;
  }

  /* Firefox Scrollbar */
  * {
    scrollbar-width: thin;
    scrollbar-color: #00ff00 #0a0a0a;
  }

  /* Custom scrollbar for specific components */
  .terminal-scrollbar::-webkit-scrollbar-thumb {
    background: linear-gradient(180deg, #00ff00, #00ffff);
  }

  .skills-scrollbar::-webkit-scrollbar-thumb {
    background: linear-gradient(180deg, #ffff00, #00ff00);
  }

  /* Scrollbar animations */
  ::-webkit-scrollbar-thumb {
    transition: all 0.3s ease;
  }

  /* MOBILE-ONLY FIXES - Only apply to mobile devices */
  @media (max-width: 768px) and (pointer: coarse) {
    /* Only target mobile devices with touch screens */
    
    /* Mobile scrollbar - thinner for touch */
    ::-webkit-scrollbar {
      width: 6px;
      height: 6px;
    }
    
    /* Better touch scrolling */
    * {
      -webkit-overflow-scrolling: touch;
    }
    
    /* Fix mobile window content ONLY */
    .mobile-window-content {
      padding-bottom: 30px !important;
      box-sizing: border-box;
    }
    
    /* Prevent content cut-off in mobile apps */
    .mobile-app-container {
      min-height: calc(100vh - 60px);
      padding-bottom: 20px;
    }
    
    /* Smooth scrolling for mobile */
    html {
      scroll-behavior: smooth;
    }
  }
`;

export default GlobalScrollbarStyles;
